import React from 'react'
import NextHead from 'next/head'
import { useStoreConfig } from 'config/hooks/useStoreConfig'

type PotentialAction = {
    '@type': 'SearchAction'
    target: {
        '@type': string
        urlTemplate: string
    }
    'query-input': string
}

export const SearchBox = ({
    asPath
}: {
    asPath: string
}): JSX.Element | null => {
    const { seo, base } = useStoreConfig()
    if (
        !seo.searchBox ||
        asPath !== seo.searchBox.allowedPath ||
        !seo.searchBox.potentialActions
    ) {
        return null
    }
    const content = {
        '@context': 'https://schema.org',
        '@type': 'WebSite',
        url: base.url.baseUrl,
        potentialAction: {}
    }

    seo.searchBox.potentialActions.forEach((action) => {
        if (action && action.target && action.queryInput) {
            content.potentialAction = {
                '@type': 'SearchAction',

                target: {
                    '@type': 'EntryPoint',
                    urlTemplate: `${action.target}={${action.queryInput}}`
                },
                'query-input': `required name=${action.queryInput}`
            }
        }
    })

    return (
        <NextHead>
            <script
                type="application/ld+json"
                dangerouslySetInnerHTML={{
                    __html: JSON.stringify(content, null, '\t')
                }}
            />
        </NextHead>
    )
}
